import React, { useState } from 'react';
import { Table, Card, Button, Collapse } from 'react-bootstrap';
import { FiTrendingUp, FiTrendingDown, FiMinus, FiUser, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import PropTypes from 'prop-types';
import ImagenPerfil from '../../components/common/ImagenPerfil'
import SoftBadge from '../../components/common/SoftBadge';
const TablaPromediosVendedores = ({ promediosData, selectedYear }) => {
    const [expandedRow, setExpandedRow] = useState(null);

    // Función para alternar el colapso de filas en móvil
    const toggleRowExpand = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    // Usar los años directamente basados en selectedYear
    const year1 = selectedYear - 2;
    const year2 = selectedYear - 1;
    const year3 = selectedYear;

    // Función para formatear el texto del porcentaje (simplificada)
    const formatPercentageText = (percentage) => {
        if (percentage === 999.9) return "+100%";
        if (percentage === -100) return "-100%";
        if (percentage === 0) return "0.0%";
        return `${percentage >= 0 ? '+' : ''}${percentage}%`;
    };

    // Función para formatear el dinero
    const formatMoney = (amount) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    // Función para determinar el color, icono y badge del porcentaje (actualizada)
    const getPercentageInfo = (percentage) => {
        if (percentage > 0 || percentage === 999.9) {
            return {
                //color: '#198754',
                //bgColor: '#d1e7dd',
                //borderColor: '#198754',
                icon: <FiTrendingUp className="me-1" />,
                badgeVariant: 'success',
                textClass: 'success'
            };
        } else if (percentage < 0) {
            return {
                //color: '#dc3545',
                //bgColor: '#f8d7da',
                //borderColor: '#dc3545',
                icon: <FiTrendingDown className="me-1" />,
                badgeVariant: 'danger',
                textClass: 'danger'
            };
        } else {
            return {
                //color: '#6c757d',
                //bgColor: '#e9ecef',
                //borderColor: '#6c757d',
                icon: <FiMinus className="me-1" />,
                badgeVariant: 'secondary',
                textClass: 'text-muted'
            };
        }
    };

    // Verificar si tenemos los datos necesarios
    if (!promediosData || !Array.isArray(promediosData) || promediosData.length === 0) {
        throw new Error("No se recibió la data necesaria");
    }

    return (
        <Card className=" shadow-sm border-0">
            <Card.Body className="p-0">
                {/* Tabla para Desktop */}
                <div className="table-responsive d-none d-lg-block">
                    <Table className="mb-0" hover style={{ minWidth: '800px' }}>
                        <thead>
                            <tr>
                                <th className="border-0 py-3 ps-4" style={{ minWidth: '200px' }}>
                                    <div className="d-flex align-items-center text-muted">
                                        <FiUser className=" text-dark me-2" size={16} />
                                        <span className="fw-bold text-dark">Vendedor</span>
                                    </div>
                                </th>
                                <th className="border-0 py-3 text-center" style={{ minWidth: '150px' }}>
                                    <span className="fw-bold text-dark">{year1}</span>
                                </th>
                                <th className="border-0 py-3 text-center" style={{ minWidth: '180px' }}>
                                    <span className="fw-bold text-dark">{year2}</span>
                                </th>
                                <th className="border-0 py-3 text-center" style={{ minWidth: '180px' }}>
                                    <span className="fw-bold text-dark">{year3}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {promediosData.map((vendedor, index) => {
                                // Usar porcentajes que vienen del SQL
                                const changeYear2VsYear1 = vendedor.porcentaje_anio2_vs_anio1 || 0;
                                const changeYear3VsYear1 = vendedor.porcentaje_anio3_vs_anio1 || 0;
                                const changeYear3VsYear2 = vendedor.porcentaje_anio3_vs_anio2 || 0;

                                const badgeYear2 = getPercentageInfo(changeYear2VsYear1);
                                const badgeYear3Vs1 = getPercentageInfo(changeYear3VsYear1);
                                const badgeYear3Vs2 = getPercentageInfo(changeYear3VsYear2);

                                return (
                                    <tr key={index} className="border-bottom">
                                        <td className="py-3 ps-4">
                                            <div className="d-flex align-items-center">
                                                <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                                                    <ImagenPerfil idUsuario={vendedor.idUsuario} size={18} />
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark">{vendedor.vNombreVendedor || vendedor.nombre}</div>
                                                    <small className="text-muted">Representante de ventas</small>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="py-3 text-center">
                                            <div className="fw-bold text-dark">
                                                {formatMoney(vendedor[`promedio_${year1}`] || 0)}
                                            </div>
                                        </td>
                                        <td className="py-3 text-center">
                                            <div className="fw-bold text-dark">
                                                {formatMoney(vendedor[`promedio_${year2}`] || 0)}
                                            </div>
                                            <div className="mt-1">
                                                <SoftBadge
                                                    bg={badgeYear2.badgeVariant}
                                                    className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                    style={{ fontSize: '0.65rem' }}
                                                >
                                                    {badgeYear2.icon}
                                                    vs {year1}: {formatPercentageText(changeYear2VsYear1)}
                                                </SoftBadge>
                                            </div>
                                        </td>
                                        <td className="py-3 text-center">
                                            <div className="fw-bold text-dark">
                                                {formatMoney(vendedor[`promedio_${year3}`] || 0)}
                                            </div>
                                            <div className="mt-1 d-flex justify-content-center gap-1">
                                                <SoftBadge
                                                    bg={badgeYear3Vs1.badgeVariant}
                                                    className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                    style={{ fontSize: '0.65rem' }}
                                                >
                                                    {badgeYear3Vs1.icon}
                                                    vs {year1}: {formatPercentageText(changeYear3VsYear1)}
                                                </SoftBadge>
                                                <SoftBadge
                                                    bg={badgeYear3Vs2.badgeVariant}
                                                    className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                    style={{ fontSize: '0.65rem' }}
                                                >
                                                    {badgeYear3Vs2.icon}
                                                    vs {year2}: {formatPercentageText(changeYear3VsYear2)}
                                                </SoftBadge>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>

                {/* Vista para Tablet - Diseño compacto vertical */}
                <div className="d-none d-md-block d-lg-none">

                    <div className="p-2">
                        {promediosData.map((vendedor, index) => {
                            // Usar porcentajes que vienen del SQL
                            const changeYear2VsYear1 = vendedor.porcentaje_anio2_vs_anio1 || 0;
                            const changeYear3VsYear1 = vendedor.porcentaje_anio3_vs_anio1 || 0;
                            const changeYear3VsYear2 = vendedor.porcentaje_anio3_vs_anio2 || 0;

                            const badgeYear2 = getPercentageInfo(changeYear2VsYear1);
                            const badgeYear3Vs1 = getPercentageInfo(changeYear3VsYear1);
                            const badgeYear3Vs2 = getPercentageInfo(changeYear3VsYear2);

                            return (
                                <Card key={index} className="mb-2 shadow-sm border-0">
                                    <Card.Body className="p-3">
                                        <div className="d-flex align-items-center justify-content-between">
                                            {/* Info del vendedor */}
                                            <div className="d-flex align-items-center flex-shrink-0" style={{ minWidth: '180px' }}>
                                                <ImagenPerfil idUsuario={vendedor.idUsuario} size={16} />
                                                <div className="ms-2">
                                                    <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>
                                                        {vendedor.vNombreVendedor || vendedor.nombre}
                                                    </div>
                                                    <small className="text-muted" style={{ fontSize: '0.7rem' }}>Rep. Ventas</small>
                                                </div>
                                            </div>

                                            {/* Datos de ventas en línea horizontal */}
                                            <div className="d-flex align-items-start gap-3 flex-grow-1 justify-content-end">
                                                {/* Año 1 */}
                                                <div className="text-center" style={{ minWidth: '95px', minHeight: '70px' }}>
                                                    <div className="small text-muted mb-1" style={{ fontSize: '0.7rem' }}>{year1}</div>
                                                    <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>
                                                        {formatMoney(vendedor[`promedio_${year1}`] || 0)}
                                                    </div>
                                                    {/* Espaciador para mantener altura uniforme */}
                                                    <div style={{ height: '26px' }}></div>
                                                </div>

                                                {/* Separador visual */}
                                                <div className="text-muted align-self-center">→</div>

                                                {/* Año 2 */}
                                                <div className="text-center" style={{ minWidth: '95px', minHeight: '70px' }}>
                                                    <div className="small text-muted mb-1" style={{ fontSize: '0.7rem' }}>{year2}</div>
                                                    <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>
                                                        {formatMoney(vendedor[`promedio_${year2}`] || 0)}
                                                    </div>
                                                    <div className="mt-1">
                                                        <SoftBadge
                                                            bg={badgeYear2.badgeVariant}
                                                            className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                            style={{ fontSize: '0.65rem' }}
                                                        >
                                                            {badgeYear2.icon}
                                                            vs {year1}: {formatPercentageText(changeYear2VsYear1)}
                                                        </SoftBadge>
                                                    </div>
                                                </div>

                                                {/* Separador visual */}
                                                <div className="text-muted align-self-center">→</div>

                                                {/* Año 3 - Destacado */}
                                                <div className="text-center" style={{ minWidth: '140px', minHeight: '70px' }}>
                                                    <div className="small text-muted mb-1" style={{ fontSize: '0.7rem' }}>{year3}</div>
                                                    <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>
                                                        {formatMoney(vendedor[`promedio_${year3}`] || 0)}
                                                    </div>
                                                    <div className="d-flex flex-column gap-1 mt-1 align-items-center">
                                                        <SoftBadge
                                                            bg={badgeYear3Vs1.badgeVariant}
                                                            className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                            style={{ fontSize: '0.6rem' }}
                                                        >
                                                            {badgeYear3Vs1.icon}
                                                            vs {year1}: {formatPercentageText(changeYear3VsYear1)}
                                                        </SoftBadge>
                                                        <SoftBadge
                                                            bg={badgeYear3Vs2.badgeVariant}
                                                            className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                            style={{ fontSize: '0.6rem' }}
                                                        >
                                                            {badgeYear3Vs2.icon}
                                                            vs {year2}: {formatPercentageText(changeYear3VsYear2)}
                                                        </SoftBadge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            );
                        })}
                    </div>
                </div>

                {/* Vista para Móvil */}
                <div className="d-block d-md-none">

                    {promediosData.map((vendedor, index) => {
                        // Usar porcentajes que vienen del SQL
                        const changeYear2VsYear1 = vendedor.porcentaje_anio2_vs_anio1 || 0;
                        const changeYear3VsYear1 = vendedor.porcentaje_anio3_vs_anio1 || 0;
                        const changeYear3VsYear2 = vendedor.porcentaje_anio3_vs_anio2 || 0;

                        const badgeYear2 = getPercentageInfo(changeYear2VsYear1);
                        const badgeYear3Vs1 = getPercentageInfo(changeYear3VsYear1);
                        const badgeYear3Vs2 = getPercentageInfo(changeYear3VsYear2);
                        const isExpanded = expandedRow === index;

                        return (
                            <div key={index} className="border-bottom" style={{ borderColor: '#e9ecef', borderWidth: '1px' }}>
                                {/* Header clickeable */}
                                <div
                                    className="p-3 cursor-pointer"
                                    onClick={() => toggleRowExpand(index)}
                                    style={{ cursor: 'pointer', minHeight: '110px' }}
                                >
                                    <div className="d-flex align-items-start justify-content-between h-100">
                                        <div className="d-flex align-items-start flex-grow-1">
                                            <ImagenPerfil idUsuario={vendedor.idUsuario} size={16} />
                                            <div className="ms-3 flex-grow-1">
                                                <div className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>
                                                    {vendedor.vNombreVendedor || vendedor.nombre}
                                                </div>
                                                <div className="mt-1">
                                                    <div className="small text-muted" style={{ fontSize: '0.9rem' }}>{year3}</div>
                                                    <span className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                                        {formatMoney(vendedor[`promedio_${year3}`] || 0)}
                                                    </span>
                                                </div>
                                                {/* Badges siempre abajo y en la misma línea */}
                                                <div className="mt-2 d-flex flex-wrap gap-1">
                                                    <SoftBadge
                                                        bg={badgeYear3Vs1.badgeVariant}
                                                        className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                        style={{ fontSize: '0.6rem' }}
                                                    >
                                                        {badgeYear3Vs1.icon}
                                                        vs {year1}: {formatPercentageText(changeYear3VsYear1)}
                                                    </SoftBadge>
                                                    <SoftBadge
                                                        bg={badgeYear3Vs2.badgeVariant}
                                                        className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                        style={{ fontSize: '0.6rem' }}
                                                    >
                                                        {badgeYear3Vs2.icon}
                                                        vs {year2}: {formatPercentageText(changeYear3VsYear2)}
                                                    </SoftBadge>
                                                </div>
                                                {/* Espaciador para altura uniforme */}
                                                <div style={{ height: '10px' }}></div>
                                            </div>
                                        </div>
                                        <Button variant="link" size="sm" className="p-0 text-muted align-self-start">
                                            {isExpanded ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
                                        </Button>
                                    </div>
                                </div>

                                {/* Detalles expandibles */}
                                <Collapse in={isExpanded}>
                                    <div className="px-3 pb-3">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="p-2 rounded" style={{ minHeight: '80px' }}>
                                                    <div className="small text-muted">{year1}</div>
                                                    <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                                        {formatMoney(vendedor[`promedio_${year1}`] || 0)}
                                                    </div>
                                                    {/* Espaciador para altura uniforme */}
                                                    <div style={{ height: '24px' }}></div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="p-2 rounded" style={{ minHeight: '80px' }}>
                                                    <div className="small text-muted">{year2}</div>
                                                    <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                                        {formatMoney(vendedor[`promedio_${year2}`] || 0)}
                                                    </div>
                                                    <div className="mt-1">
                                                        <SoftBadge
                                                            bg={badgeYear2.badgeVariant}
                                                            className="px-2 py-1 rounded-pill d-inline-flex align-items-center"
                                                            style={{ fontSize: '0.6rem' }}
                                                        >
                                                            {badgeYear2.icon}
                                                            vs {year1}: {formatPercentageText(changeYear2VsYear1)}
                                                        </SoftBadge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        );
                    })}
                </div>
            </Card.Body>

            {/* Footer con leyenda moderna */}
            <Card.Footer className="bg-light border-0">
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center">
                        <SoftBadge bg="success" className="me-2 rounded-pill">
                            <FiTrendingUp size={12} />
                        </SoftBadge>
                        <small className="text-muted">Incremento</small>
                    </div>
                    <div className="d-flex align-items-center">
                        <SoftBadge bg="danger" className="me-2 rounded-pill">
                            <FiTrendingDown size={12} />
                        </SoftBadge>
                        <small className="text-muted">Decremento</small>
                    </div>
                    <div className="d-flex align-items-center">
                        <SoftBadge bg="secondary" className="me-2 rounded-pill">
                            <FiMinus size={12} />
                        </SoftBadge>
                        <small className="text-muted">Sin cambio</small>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
};

TablaPromediosVendedores.propTypes = {
    promediosData: PropTypes.arrayOf(
        PropTypes.shape({
            vNombreVendedor: PropTypes.string,
            nombre: PropTypes.string,
            idUsuario: PropTypes.number
        })
    ),
    selectedYear: PropTypes.number.isRequired
};

export default TablaPromediosVendedores;